import React from 'react';
import { MetricCard } from '../metrics/MetricCard';
import { Message, Task } from '../../types';
import { TrendingUp, Users, MessageSquare, CheckCircle } from 'lucide-react';
import { calculateMetrics } from '../../utils/analytics';
import { motion } from 'framer-motion';

interface CommunicationMetricsProps {
  messages: Message[];
  tasks: Task[];
}

export const CommunicationMetrics: React.FC<CommunicationMetricsProps> = ({ messages, tasks }) => {
  const metrics = calculateMetrics(messages, tasks);
  const completedTasks = tasks.filter(t => t.status === 'COMPLETED').length;
  const totalTasks = tasks.length;
  const taskCompletionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <MetricCard
          title="Task Completion"
          value={`${taskCompletionRate}%`}
          icon={<CheckCircle />}
          trend={`${completedTasks} of ${totalTasks} tasks`}
          color="emerald"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <MetricCard
          title="Active Users"
          value={metrics.activeUsers.toString()}
          icon={<Users />}
          trend={`${metrics.activeUsersTrend}% engagement`}
          color="blue"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <MetricCard
          title="Response Rate"
          value={`${metrics.responseRate}%`}
          icon={<TrendingUp />}
          trend={`${metrics.responseRateTrend}% from average`}
          color="purple"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <MetricCard
          title="Total Communications"
          value={metrics.totalMessages.toString()}
          icon={<MessageSquare />}
          trend={`${metrics.messagesTrend}% from last week`}
          color="orange"
        />
      </motion.div>
    </div>
  );
};